
<!-- TODO: WARNING: DEPRECATED??? -->
 
<!-- TODO: Multilang -->
<template>
  <div id="processforms" class="process_forms">
    <ProcessesOrgChart 
      :key="refresh_org_charts"
      :standard="standards"
      :roles="allRoles"
      :departments="departments"
      :allProcesses="processes"
      :view="view"
      @refresh="refresh"
      @update_view="update_view"
    ></ProcessesOrgChart>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Roles from '@/api/Roles'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import QStandard from '@/api/Standard'
import ProcessesOrgChart from '@/components/process/ProcessesOrgChart'


export default {
    name: 'qprocess_map',
    cache: false,
    
    data: function() {
        return {
            loading: false,
            message: null,
            current_standard_id: null,
            standards: [],
            currentStandard: {},
            newStandard: {},
            currentProcess: {},
            newProcess: {},
            newPermission: {},
            aspects: [],
            newAspect: {},
            current_standard_aspects: [],
            allRoles: [],
            allDepartments: [],
            mapstandard: {},
            showModalDialog: false,
            modal_title:"ADD STANDARD",
            fields_to_collect:[
              [{
                id:	"name",
                label:	"Nombre",
                required:	false,
                value:	null,
                readonly:	false,
                hidden:	null,
                cols:	8,
                class:	null,
                component:	"TextInput",
                placeholder:"Introducir nombre"
              }]
            ],
            submit_button_caption:"GUARDAR", // Harcoded text
            refresh_org_charts: 0,
            view: 'OrgChart',
        }
    },    
    components: { ModalDialogForm , ProcessesOrgChart},
    computed: { 
      ...mapGetters(['isAdmin', 'sitePath']),
      ...mapState(['allProcesses']),
      departments() {
        return this.sortArrayBy(this.allDepartments);
      },
      processes() {
        return this.sortArrayBy(this.allProcesses);
      }
    },
    mounted: function() {
        this.getStandards();
        this.getRoles();
        this.getDepartments();
    },
    methods: {
        ...mapActions(['LOAD_PROCESSES',]),
        refresh() {
            this.getStandards();
            this.getProcesses();
        },
        update_view(view) {
            this.view = view;
        },
        addStandardForm: function() {
            this.message = ''
            this.newStandard = {}
            this.showModalDialog = true
        },

        addStandard: function(formdata) {

            this.loading = true
            this.message = ''
            QStandard.createQStandard(this.sitePath, formdata)
            .then(() => {
                // this.loading = false
                this.getStandards(this.sitePath)
                // this.$refs.addmodalstandard.hide()
                this.toggle_dialog()
                this.$root.$loader.hide()
                })
                .catch(err => {
                    //TODO:
                    this.render_form_errors(err)
                })
        },
        getStandards: function() {
            QStandard.getQStandardItems(this.sitePath)
            .then(data => {
                this.standards = data['results']
                this.loading = false
                })
                .catch(err => {
                this.loading = false
                alert(err)
                })
        },
        toggle_dialog() {
            this.showModalDialog = false            
            // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
        },
        async getRoles() {
            await Roles.get(this.sitePath)
                .then(response => {
                    this.allRoles = []
                    for (var role of response.results) {
                        this.allRoles.push({ value: role.id, text: role.name })
                    }
                })
                .catch(err => {
                    this.render_form_errors(err)
                })
        },
        async getDepartments() {
        this.loading = true
            await this.$http
                .get(this.$base + '/api/v1' + this.sitePath + '/department/',)
                .then(response => {
                    this.allDepartments = []
                    for (var dep of response.data['results']) {
                        this.allDepartments.push({ value: dep.id, text: dep.name })
                    }
                    this.loading = false
                })
                .catch(err => {
                    this.render_form_errors(err)
                })
        },
        async getProcesses() {
            this.LOAD_PROCESSES(this.sitePath);
        },
        sortArrayBy(array, param) {
            let sort_array = array;
            sort_array.sort((a, b) =>
                a[param] > b[param]
                ? 1
                :
                a[param] === b[param]
                ?
                    a[param]
                    ? -1
                    : 1
                : -1,
            )
            return sort_array;
        },
    },
    watch: {
    },
}
</script>


<style lang="scss">
  @import "@/sass/processmap.scss";
  .process_forms {
    height: 100%;
  }
</style>
